var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.rootClass},[_c('span',{class:`${_vm.rootClass}__vignette`}),_vm._v(" "),_c('span',{class:`${_vm.rootClass}__filter`}),_vm._v(" "),_c('div',{class:`${_vm.rootClass}__wrapper`},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }